import { AppleCommandPayload } from './apple-command.model';

enum Queries {
  'UDID' = 0,
  'Languages' = 1,
  'Locales' = 2,
  'OrganizationInfo' = 3,
  'LastCloudBackupDate' = 4,
  'AwaitingConfiguration' = 5,
  'AutoSetupAdminAccounts' = 6,
  'DeviceName' = 7,
  'OSVersion' = 8,
  'BuildVersion' = 9,
  'ModelName' = 10,
  'Model' = 11,
  'ProductName' = 12,
  'SerialNumber' = 13,
  'DevicyCapacity' = 14,
  'AvailableDeviceCapacity' = 15,
  'BatteryLevel' = 16,
  'CellularTechnology' = 17,
  'IMEI' = 18,
  'MEID' = 19,
  'ModemFirmwareVersion' = 20,
  'IsSupervised' = 21,
  'IsDeviceLocatorServiceEnabled' = 22,
  'IsActivationLockEnabled' = 23,
  'IsDoNotDisturbInEffect' = 24,
  'DeviceID' = 25,
  'EASDeviceIdentifier' = 26,
  'IsCloudBackupEnabled' = 27,
  'OSUpdateSettings' = 28,
  'LocalHostName' = 29,
  'HostName' = 30,
  'SystemIntegrityProtectionEnabled' = 31,
  'ActiveManagedUsers' = 32,
  'IsMDMLostModeEnabled' = 33,
  'MaximumResidentUsers' = 34,
  'iTunesStoreAccountIsActive' = 35,
  'iTunesStoreAccountHash' = 36,
}

export class DeviceInformationCommand extends AppleCommandPayload {
  public queries: string[];

  constructor(queries: string[]) {
    super();

    this.queries = queries;
    this.requestType = 'DeviceInformation';
  }
}

export class QueryList {
  public get all() {
    const queries: string[] = [];

    for (const item in Queries) {
      if (typeof Queries[item] !== 'number') {
        const query = this.get(item);
        queries.push(query);
      }
    }

    return queries;
  }

  public get(query: string): string {
    return Queries[query];
  }
}
